module.exports = __webpack_public_path__ + "img/微课02.8ecd04ff.svg";